export default {
    modal: {
        confirmOrder: {
            title: "Potvrda narudžbine",
            orderNumber: "Broj narudžbine",
            orderDate: "Datum narudžbine",
            totalSum: "Ukupna suma",
            quantity: "Količina",
            status: "Status",
            store: "Prodavnica",
            button: {
                confirm: "Potvrdi",
                close: "Zatvori"
            }
        },
        cancelOrder: {
            title: "Otkaži narudžbinu",
            cancelWarningMessage: "Da li ste sigurni da želite da otkažete ovu narudžbinu? Jednom otkazana narudžbina se ne može obnoviti.",
            orderNumber: "Broj narudžbine",
            orderDate: "Datum narudžbine",
            totalSum: "Ukupna suma",
            quantity: "Količina",
            status: "Status",
            store: "Prodavnica",
            button: {
                cancel: "Zatvori",
                close: "Otkaži"
            }
        },
        rateProduct: {
            title: "Ocijenite proizvod",
            orderDate: "Datum",
            totalSum: "Ukupna suma",
            quantity: "Količina",
            subtitle: {
                rateProduct: "Ocijenite proizvod",
                leaveComment: "Ostavite komentar"
            },
            optional: "opciono",
            button: {
                close: "Zatvori",
                rate: "Ocijeni"
            }
        }
    }
};

